import { useMutation } from '@redwoodjs/web';
import { useEffect, useState } from 'react';
import { showSuccessToast } from 'src/components/Toasts/toast';
import { REMIND_SEPA_DD } from 'src/graphql/mutations/sepaDD.mutation';
import { SEPA_MANDATE_AGREEMENT_TABLE_TYPE } from 'src/utils/tableUtils';
import { onError } from 'src/utils/utils';

export function useRemindSepaAgreement({ merchantData, partnerData }) {
    const [isRemindConfirmModalOpen, setIsRemindConfirmModalOpen] = useState<boolean>(false);
    const [idToRemind, setIdToRemind] = useState<{
        id: number;
        agreementType: SEPA_MANDATE_AGREEMENT_TABLE_TYPE;
    }>();
    const [remindData, setRemindData] = useState<unknown>();

    const [remindSepaDD] = useMutation(REMIND_SEPA_DD, {
        onError,
        onCompleted: () => {
            showSuccessToast('Reminder sent successfully.');
        },
    });

    const handleRemindRecord = () => {
        if (idToRemind) {
            remindSepaDD({
                variables: {
                    id: idToRemind?.id,
                },
            });
        }
        setIsRemindConfirmModalOpen(false);
    };

    useEffect(() => {
        if (idToRemind) {
            if (idToRemind?.agreementType === SEPA_MANDATE_AGREEMENT_TABLE_TYPE.MERCHANT) {
                setRemindData(
                    merchantData?.getSepaMandates?.data.find(
                        (agreement) => agreement.id === idToRemind?.id?.toString()
                    )
                );
            } else if (idToRemind?.agreementType === SEPA_MANDATE_AGREEMENT_TABLE_TYPE.PARTNER) {
                setRemindData(
                    partnerData?.getSepaMandates?.data.find(
                        (agreement) => agreement.id === idToRemind?.id?.toString()
                    )
                );
            }
        }
    }, [idToRemind]);

    return {
        setIsRemindConfirmModalOpen,
        isRemindConfirmModalOpen,
        setIdToRemind,
        handleRemindRecord,
        remindData,
    };
}
